<template>
    <hmenu></hmenu>

          <main>
            <section class="breadcrumb-height ns-breadcrumb-area" style="min-height: 300px; background-image: url('/assets/img/breadcrumb/breadcrumb-bg.jpg');" >
                <img src="/assets/img/breadcrumb/shape-1.png" alt="" class="ns-breadcrumb-shape-1">
                <img src="/assets/img/breadcrumb/breadcrumb-map.png" alt="" class="ns-breadcrumb-map">
                <img src="/assets/img/breadcrumb/shape-2.png" alt="" class="ns-breadcrumb-shape-2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="ns-breadcrumb-wrap text-center">
                                <h2 class="ns-breadcrumb-title" v-html="blog.title"></h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div v-for="info in sections" class="ns-project-details-area pt-70 pb-70">
              <div class="container">
                  <div class="row">
                    <h2 class="ns-breadcrumb-title">{{info.title}}</h2>
                     <div class="col-xl-4 col-lg-5 col-md-5">
                          <div class="ns-project-details-img-2 w_img mb-40">
                              <img :src="'/asetet/img/'+info.image" alt="">
                          </div>
                      </div>
                      <div class="col-xl-8 col-lg-7 col-md-7">
                          <div class="ns-project-details-content mb-40">
                              <p class="ns-project-details-content-text">
                                {{info.subtitle}}
                              </p>
                              <blockquote class="ns-project-details-quote">
                                  <i class="icofont-quote-left"></i>
                                  <p>
                                     {{info.quote}}
                                  </p>
                              </blockquote>
                          </div>
                      </div>
                      <div class="col-12">
                        <h4>{{info.textTitle}}</h4>
                          <p class="ns-project-details-text">
                            {{info.text}}
                          </p>
                      </div>




                  </div>
                  <div class="row">
                      <div v-if="info.img1" class="col-xl-3 col-lg-3 col-md-6">
                        <img :src="'/asetet/img/'+info.img1" alt="">
                      </div>
                      <div v-if="info.img2" class="col-xl-3 col-lg-3 col-md-6">
                        <img :src="'/asetet/img/'+info.img2" alt="">
                      </div>
                      <div v-if="info.img3" class="col-xl-3 col-lg-3 col-md-6">
                        <img :src="'/asetet/img/'+info.img3" alt="">
                      </div>
                      <div v-if="info.img4" class="col-xl-3 col-lg-3 col-md-6">
                        <img :src="'/asetet/img/'+info.img4" alt="">
                      </div>
                  </div>
                  <div class="row">
                      <div v-if="info.video1" class="col-xl-3 col-lg-3 col-md-6">
                        <iframe width="315" height="460"
                          :src="info.video1"
                          title="Gpro"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowfullscreen></iframe>
                      </div>
                      <div v-if="info.video2" class="col-xl-3 col-lg-3 col-md-6">
                        <iframe width="315" height="460"
                          :src="info.video2"
                          title="Gpro"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowfullscreen></iframe>
                      </div>
                      <div v-if="info.video3" class="col-xl-3 col-lg-3 col-md-6">
                        <iframe width="315" height="460"
                          :src="info.video3"
                          title="Gpro"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowfullscreen></iframe>
                      </div>
                      
                  </div>


              </div>
            </div>

        </main>
    <Footer></Footer>
</template>

<script>
    import hmenu from './header.vue'
    import Footer from './Footer.vue'

    import blogService from "@/api/blogService";

    export default {

        data () {
          return {
            selected:'info',

            blog:{},
            sections:[]

          }
        },


        components: {
          hmenu,
          Footer,
          blogService,
         
        },




        methods:{

          tabClick(type){
            this.selected = type
          },

          async loadBlog(){

            let slug = this.$route.params.slug;

            try {

            let response = await blogService.getBlog(slug);
            this.blog = response.data.blog;
            this.sections = response.data.sections;

            }catch(error){

            console.log(error);

            }

          }


        },



        mounted(){

          this.loadBlog();
          window.scrollTo({top: 0, behavior: 'smooth'});

        }


    }

</script>



<style>


  .ns-project-details-listt ul li {
      display: flex;
      align-items: center;
      line-height: 1;
      margin-bottom: 20px;
      gap: 5px;
      font-size: 17px;
      color: var(--clr-body-text);
  }



  .kioska__ ul li{
    line-height: 1!important;
    margin-bottom: 0px!important;
    gap: 5px!important;
  }


  .hyrja__ ul li{
    line-height: 1!important;
    margin-bottom: 0px!important;
    gap: 5px!important;
  }

  .para li{
    flex-wrap: wrap!important;
  }

</style>